import { Button } from "@mui/material";
import React from "react";
import { Link } from "react-router-dom";
import { SITE_NAME } from "@/config/appConfig";
import { ROUTES } from "@/helpers/routes/routePaths";

export default function UnRegisteredEmailMessage() {
  return (
    <div className="un-registered-email-message">
      <h2 className="heading mb-3">
        Looks like your email is not associated to your brand
      </h2>
      <p className="subheading">
        We couldn’t create a new {SITE_NAME} account because we couldn’t find
        your email address in our platform.
      </p>
      <p className="subheading">
        If you believe this is a mistake, please contact your brand and they
        will help you set up your {SITE_NAME} account.
      </p>

      <div className="row justify-content-center mt-5">
        <div className="col-sm-6 col-xl-4">
          <Button
            component={Link}
            to={ROUTES.ROOT}
            variant="contained"
            color="primary"
            className="mt-4 mx-auto"
            size="large"
            fullWidth
          >
            Back to website
          </Button>
        </div>
      </div>
    </div>
  );
}
